const sensitiveSearchParamKeys = new Set([
    'acceptinvitecode',
    'accesstoken',
    'code',
    'idtoken',
    'nonce',
    'passwordresetcode',
    'refreshtoken',
    'sessionid',
    'state',
]);

const normalizeSearchParamKey = (key: string): string => {
    return key.replaceAll(/[_-]/g, '').toLowerCase();
};

export const sanitizeSearchParamsForAiContext = (
    search: string,
): Readonly<Record<string, string | readonly string[]>> => {
    const searchParams = new URLSearchParams(search);
    const sanitizedSearchParams = new Map<string, string[]>();

    for (const [key, value] of searchParams.entries()) {
        if (sensitiveSearchParamKeys.has(normalizeSearchParamKey(key))) {
            continue;
        }

        const existingValues = sanitizedSearchParams.get(key);

        if (existingValues === undefined) {
            sanitizedSearchParams.set(key, [value]);
            continue;
        }

        existingValues.push(value);
    }

    const normalizedSearchParams: Record<string, string | readonly string[]> = {};

    for (const [key, values] of sanitizedSearchParams.entries()) {
        normalizedSearchParams[key] = values.length === 1 ? values[0]! : values;
    }

    return normalizedSearchParams;
};
